import { AnimateBox } from '../../components/animate-box'
import { Wrap } from '../../components/wap'
import { STATIC_OBS_URL } from '../../consts'

const data1 = [
  {
    title: '福莲·世冠”科技奖学金获奖学生感言',
    icon: `${STATIC_OBS_URL}/website/home/responsibility/list-1.png`,
    url: 'https://mp.weixin.qq.com/s/Gsg2M8VeDYswL1oj64yhNQ'
  },
  {
    title: '2022年“福莲·世冠”科技奖学奖教金来啦！',
    icon: `${STATIC_OBS_URL}/website/home/responsibility/list-2.png`,
    url: 'https://mp.weixin.qq.com/s/hU0t_DMRyIl3dCXPPG85Rg'
  },
  {
    title: '世冠科技董事长李京燕:合作力是一种比竞争力更强大的力量',
    icon: `${STATIC_OBS_URL}/website/home/responsibility/list-3.png`,
    url: 'https://mp.weixin.qq.com/s/ktB6bx3gnXoPNdRd6X1S5A'
  }
]

const data2 = [
  {
    title: '第五届“福莲·世冠”科技奖获奖名单公示',
    icon: `${STATIC_OBS_URL}/website/home/responsibility/winner-1.png`,
    url: 'https://mp.weixin.qq.com/s/RcXOf7Afw94MWOdBYro1cw'
  },
  {
    title: '第四届 “福莲·世冠” 和科技奖学金获奖名单公示',
    icon: `${STATIC_OBS_URL}/website/home/responsibility/winner-2.png`,
    url: 'https://mp.weixin.qq.com/s/kSsJdkK-FTW0A95HntbpZw'
  }
]

const bannerUrl = `${STATIC_OBS_URL}/website/home/responsibility/banner.png`

export const ResponsibilityDetail = () => {
  return (
    <Wrap>
      <div className='responsibility-detail'>
        <div className='banner-box' style={{ backgroundImage: `url(${bannerUrl})` }}>
          <div className='wrap'>
            <AnimateBox tagName='h1'>世冠科技公益助学</AnimateBox>
            <AnimateBox animateDelay={0.5} tagName='p'>
              热心公益事业，勇担社会责任
            </AnimateBox>
          </div>
        </div>

        <div className='section-a'>
          <div className='wrap'>
            <AnimateBox tagName='h2'>
              “福莲·世冠”科技奖学奖教金是由李京燕女士创立的北京世冠金洋科技发展有限公司出资设立
            </AnimateBox>

            <AnimateBox animateDelay={0.2} tagName='p'>
              “福莲·世冠”科技奖学奖教金是由北京世冠金洋科技发展有限公司出资设立，旨在奖励考上科技类高等院校，学习航空航天、汽车制造、机械、能源动力(含核能）、计算机、电子信息等相关学科，成绩突出的连城学子，以勉励其探索科学前沿，革故鼎新，为实现国家科技自立自强贡献力量；
            </AnimateBox>
            <AnimateBox animateDelay={0.4} tagName='p'>
              奖励获奖同学所在班级的高三教师团队，以鼓励其引导、培育更多的连城学子，勤奋专注，追求卓越，以科学研究作为终生志趣!
            </AnimateBox>
          </div>
        </div>

        <div className='section-b'>
          <div className='title'>
            <AnimateBox tagName='h2'>福莲教育</AnimateBox>
          </div>
          <div className='wrap'>
            <AnimateBox animateDelay={0.2} tagName='p'>
              连城县福莲教育促进会，是由连城乡贤自愿结成的地方性、公益性、非营利性社会组织。自2016年开始筹建，并于2019年经连城县民政局批准正式成立。
            </AnimateBox>
            <AnimateBox animateDelay={0.4} className='more-box' tagName='p'>
              <a className='look-more' href='https://mp.weixin.qq.com/s/08DNTf_xNcz_A5JtDwz6AQ'>
                更多新闻
              </a>
            </AnimateBox>
            <ul className='list'>
              {data1.map((item, i) => {
                const { title, icon, url } = item
                return (
                  <AnimateBox animateDelay={0.4 + 0.2 * i} key={title} tagName='li'>
                    <div className='img'>
                      <div className='pic' style={{ backgroundImage: `url(${icon})` }} />
                    </div>
                    <div className='info'>
                      <h5>
                        <a href={url} rel='noreferrer' target='_blank'>
                          {title}
                        </a>
                      </h5>
                      <a className='look-more' href={url} rel='noreferrer' target='_blank'>
                        了解更多
                      </a>
                    </div>
                  </AnimateBox>
                )
              })}
            </ul>
          </div>
        </div>

        <div className='section-c'>
          <div className='title'>
            <AnimateBox tagName='h2'>获奖名单</AnimateBox>
          </div>
          <div className='wrap'>
            <ul className='list'>
              {data2.map((item, i) => {
                const { title, icon, url } = item
                return (
                  <AnimateBox animateDelay={0.4 + 0.2 * i} key={title} tagName='li'>
                    <div className='img'>
                      <div className='pic' style={{ backgroundImage: `url(${icon})` }} />
                    </div>
                    <div className='info'>
                      <h5>
                        <a href={url} rel='noreferrer' target='_blank'>
                          {title}
                        </a>
                      </h5>
                      <a className='look-more' href={url} rel='noreferrer' target='_blank'>
                        更多新闻
                      </a>
                    </div>
                  </AnimateBox>
                )
              })}
            </ul>
          </div>
        </div>
      </div>
    </Wrap>
  )
}
